module.exports = __webpack_public_path__ + "images/dd781968300c811ca673a53c5050acb7.svg";